// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1O3Vr","log":"ModalInventoryLogs_log__OEBbc","date":"ModalInventoryLogs_date__2fsxD","userName":"ModalInventoryLogs_userName__1HEZQ"};